import { render } from "./ManagerForm.vue?vue&type=template&id=5060f6d2&scoped=true"
import script from "./ManagerForm.vue?vue&type=script&lang=js"
export * from "./ManagerForm.vue?vue&type=script&lang=js"

import "./ManagerForm.vue?vue&type=style&index=0&id=5060f6d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5060f6d2"]])

export default __exports__